import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StoriesFromField.scss';

const StoriesFromField = () => {
  const navigate = useNavigate();
  
  const stories = [
    {
      id: 1,
      slug: 'solar-power-transforms-rural-kenya',
      image: '/images/stories/stories3.png',
      title: 'Solar Power Transforms Rural Kenya: A Community Success Story',
      description: 'How a small village in Kenya achieved 100% renewable energy access through innovative solar solutions and community collaboration.',
      date: 'Published on January 15, 2024'
    },
    {
      id: 2,
      slug: 'wind-energy-morocco-desert',
      image: '/images/stories/stories2.png',
      title: 'Harnessing the Desert Winds: Morocco\'s Renewable Energy Revolution',
      description: 'Morocco\'s ambitious wind energy projects in the Sahara Desert are setting new standards for renewable energy development in Africa.',
      date: 'Published on January 10, 2024'
    },
    {
      id: 3,
      slug: 'hydroelectric-ethiopia-nile',
      image: '/images/stories/stories1.png',
      title: 'The Grand Ethiopian Renaissance Dam: Powering a Nation\'s Future',
      description: 'Ethiopia\'s massive hydroelectric project on the Blue Nile represents a new era of energy independence and regional cooperation.',
      date: 'Published on January 5, 2024'
    }
  ];

  const handleStoryClick = (slug) => {
    navigate(`/blog/${slug}`);
  };

  return (
    <section className="stories-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Stories from the Field</h2>
          <p className="section-subtitle">
            First-hand accounts from communities, innovators, and changemakers on the frontlines of energy transformation.
          </p>
        </div>

        <div className="stories-grid">
          {stories.map(story => (
            <article 
              key={story.id} 
              className="story-card"
              onClick={() => handleStoryClick(story.slug)}
            >
              <div className="story-image">
                <img src={story.image} alt={story.title} />
              </div>
              <div className="story-content">
                <h3 className="story-title">{story.title}</h3>
                <p className="story-description">{story.description}</p>
                <p className="story-date">{story.date}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoriesFromField;



